/**
 * import and init third party
 * components/validators and other dependencies
 */

import { extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
const regexEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const regexUsername = /^[a-zA-Z_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂ ưăạảấầẩẫậắằẳẵặẹếẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\s]+$/
const regexFullName = /^[a-zA-Z_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂ ưăạảấầẩẫậắằẳẵặẹếẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\s]+$/

// install rules
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

extend('fullName', value => {
  const check = regexFullName.test(String(value).toLowerCase())
  if (!check) {
    return '{_field_} không đúng định dạng'
  }
  return true
})

extend('confirmed', {
  ...rules.confirmed,
  message: '{_field_} không trùng nhau',
});
extend('min', {
  ...rules.min,
  message: '{_field_} phải lớn hơn {length} ký tự',
});

extend('required', value => {
  if (value) {
    return true
  }

  return '{_field_} không được để trống'
})

extend('username', value => {
  const check = regexUsername.test(String(value).toLowerCase())
  if (!check) {
    return '{_field_} không đúng định dạng'
  }
  if (check) {
    return true
  }

  return '{_field_} bắt buộc nhập'
})

extend('mail', value => {
  if (value.length < 3 && value.length > 255) {
    return '{_field_} được nhập tối đa 255 ký tự'
  }
  const check = regexEmail.test(String(value).toLowerCase())
  if (!check) {
    return '{_field_} không đúng định dạng'
  }
  if (check) {
    return true
  }
})

extend('requiredDate', value => {
  if (value.startDate && value.endDate) {
    return true
  }

  return '{_field_} là bắt buộc nhập'
})

extend('between', {
  params: ['min', 'max'],
  validate (value, { min, max }) {
    return value.length >= min && value.length <= max
  },
  message: '{_field_} ít nhất là {min} ký tự và nhiều nhất {max} ký tự'
})

extend('maxLength', {
  params: ['max'],
  validate (value, { max }) {
    return value.length <= max
  },
  message: '{_field_} được nhập tối đa {max} ký tự'
})